import { z } from 'zod';

// The customer's invoices, as the server presents them: one shape whatever
// produced the invoice, approved invoices only. Dates are ISO dates.
export const invoiceLineSchema = z.object({
  description: z.string(),
  quantityTonnes: z.number().nullable(),
  amount: z.number(),
  currency: z.string(),
});

export const invoiceSummarySchema = z.object({
  id: z.string(),
  type: z.string(),
  periodStart: z.string(),
  periodEnd: z.string(),
  cargo: z.string().nullable(),
  approvedOn: z.string().nullable(),
  total: z.number(),
  currency: z.string(),
});

export const invoiceSchema = invoiceSummarySchema.extend({
  lines: invoiceLineSchema.array(),
});

export type InvoiceLine = z.infer<typeof invoiceLineSchema>;
export type InvoiceSummary = z.infer<typeof invoiceSummarySchema>;
export type Invoice = z.infer<typeof invoiceSchema>;
